import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material UI components
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";

// Core Components
import MDCModal from "../../../core/MDCModal";
import MDCButton from "../../../core/MDCButton";
import MDCLoader from "../../../core/MDCLoader";

// Assets
import carLogo from "../../../../assets/images/my_digital_car.svg";

// Actions
import { finWhiteListActions } from "../../../../store/actions/appLoginDashboard/finWhiteListActions";

const useStyles = makeStyles((theme) => ({
  headerCss: {
    padding: "2rem",
    alignItems: "center",
  },
  headerColor: { color: theme.palette.MDCColors.black },
  labelCss: { color: theme.palette.MDCColors.color18 },
  finWhiteListDeleteLoader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  textColor: {
    color: theme.palette.MDCColors.textColor,
  },
}));

const NewsAndUpdatesDetailView = ({
  show,
  handleClose,
  newsId,
  newAndUpdateDetailView,
}) => {
  const [showLoader, setShowLoader] = useState();

  const dispatch = useDispatch();

  const newAndUpdateContentDetails = useSelector(
    (state) => state.finWhiteListReducer?.newAndUpdateContentDetails
  );

  useEffect(() => {
    setShowLoader(true);
    dispatch(finWhiteListActions.getNewsAndUpdatesDetailsView(newsId)).then(
      () => {
        setShowLoader(false);
      }
    );
  }, []);

  const { headerCss, headerColor, finWhiteListDeleteLoader, textColor } =
    useStyles();

  const getModalHeader = () => {
    return (
      <Grid container className={headerCss}>
        <Grid item xs={7} className={headerColor}>
          <h4>News & Updates</h4>
        </Grid>
        <Grid item xs={5}>
          <img alt="My Digital Car" src={carLogo} width={"95%"} />
        </Grid>
      </Grid>
    );
  };

  const getModalBody = () => {
    return (
      <Grid container padding="2rem" flexDirection="column">
        {showLoader ? (
          <Grid container className={finWhiteListDeleteLoader}>
            <MDCLoader />
          </Grid>
        ) : (
          <div className="newAndUpdateDetailView">
            <h3>{newAndUpdateDetailView?.subject}</h3>
            <p className={textColor}>{newAndUpdateDetailView?.summary}</p>

            <div
              dangerouslySetInnerHTML={{
                __html: newAndUpdateContentDetails,
              }}
            />
          </div>
        )}
      </Grid>
    );
  };

  const getModalFooter = () => {
    return (
      <Grid container padding="2rem" alignItems="center" flexDirection="column">
        <Grid container display={"flex"} justifyContent={"flex-end"}>
          <MDCButton
            variant="outlined"
            label={"Schließen"}
            onClick={() => {
              handleClose();
            }}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <div>
      <MDCModal
        open={show}
        title={getModalHeader()}
        body={getModalBody()}
        footer={getModalFooter()}
        size="md"
        isScroll
      />
    </div>
  );
};

export default NewsAndUpdatesDetailView;
